import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = self.customSetting.FileMgmtController;
const getController = self.customSetting.getFileMgmt;
// const postController = self.customSetting.postFileMgmt;

export default {
  // 5-6
  getFileType: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryDwnDocumentType`)
        .then((res) => {
          context.commit("GET_FILETYPE_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAllFiles: (context, dType) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryDwnDocument?dType=${dType}`)
        .then((res) => {
          context.commit("GET_ALLFILE_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
